import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { BrowserTracing } from '@sentry/tracing';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry.dsn,
  environment: environment.sentry.environment,
  // Adds request headers and IP for users, for more info visit:

  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.routingInstrumentation,
      tracingOrigins: ['localhost', /^\//],
    }),
  ],

  tracesSampleRate: 0.25,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
